'use strict';

// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_FONT_COLOR = exports.BASE_FONT_COLOR = '#33475b';
var BASE_LINK_COLOR = exports.BASE_LINK_COLOR = '#0091ae';
var BASE_LINK_ACTIVE_COLOR = exports.BASE_LINK_ACTIVE_COLOR = '#7fd1de';
var BASE_LINK_HOVER_COLOR = exports.BASE_LINK_HOVER_COLOR = '#007a8c';
var BASE_SELECTION_BACKGROUND_COLOR = exports.BASE_SELECTION_BACKGROUND_COLOR = '#eaf0f6';
var BASE_BACKGROUND_COLOR = exports.BASE_BACKGROUND_COLOR = '#ffffff';
var BASE_BACKGROUND_COLOR_MEDIUM = exports.BASE_BACKGROUND_COLOR_MEDIUM = '#f5f8fa';
var BASE_BACKGROUND_COLOR_DARK = exports.BASE_BACKGROUND_COLOR_DARK = '#33475b';
var BASE_FONT_CONTRAST_COLOR = exports.BASE_FONT_CONTRAST_COLOR = '#ffffff';
var BASE_SHADOW_COLOR = exports.BASE_SHADOW_COLOR = '#000000';
var BUTTON_DISABLED_BACKGROUND_COLOR = exports.BUTTON_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
var CARD_SHADOW_COLOR = exports.CARD_SHADOW_COLOR = '#2d3e50';
var FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = '#425b76';
var FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = '#516f90';
var FLOATING_BUTTON_GROUP_ITEM_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_COLOR = '#ffffff';
var FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = '#516f90';
var FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = '#33475b';
var CODE_BACKGROUND_COLOR = exports.CODE_BACKGROUND_COLOR = '#eaf0f6';
var CODE_FOREGROUND_COLOR = exports.CODE_FOREGROUND_COLOR = '#33475b';
var CODE_BLOCK_BACKGROUND_COLOR = exports.CODE_BLOCK_BACKGROUND_COLOR = '#f5f8fa';
var CONNECTED_STEP_SELECTED_COLOR = exports.CONNECTED_STEP_SELECTED_COLOR = '#ff7a59';
var CONNECTED_STEP_UNSELECTED_COLOR = exports.CONNECTED_STEP_UNSELECTED_COLOR = '#cbd6e2';
var DARK_LINK_COLOR = exports.DARK_LINK_COLOR = '#ffffff';
var DARK_LINK_ACTIVE_COLOR = exports.DARK_LINK_ACTIVE_COLOR = '#eaf0f6';
var DARK_LINK_HOVER_COLOR = exports.DARK_LINK_HOVER_COLOR = '#7fd1de';
var DARK_LINK_ICON_COLOR = exports.DARK_LINK_ICON_COLOR = '#ffffff';
var BRIGHT_LINK_COLOR = exports.BRIGHT_LINK_COLOR = '#33475b';
var BRIGHT_LINK_ACTIVE_COLOR = exports.BRIGHT_LINK_ACTIVE_COLOR = '#33475b';
var BRIGHT_LINK_HOVER_COLOR = exports.BRIGHT_LINK_HOVER_COLOR = '#33475b';
var BRIGHT_LINK_ICON_COLOR = exports.BRIGHT_LINK_ICON_COLOR = '#425b76';
var DANGER_LINK_COLOR = exports.DANGER_LINK_COLOR = '#f2545b';
var DANGER_LINK_ACTIVE_COLOR = exports.DANGER_LINK_ACTIVE_COLOR = '#d94c53';
var DANGER_LINK_HOVER_COLOR = exports.DANGER_LINK_HOVER_COLOR = '#d94c53';
var MENTION_LINK_COLOR = exports.MENTION_LINK_COLOR = '#425b76';
var MENTION_LINK_ACTIVE_COLOR = exports.MENTION_LINK_ACTIVE_COLOR = '#33475b';
var MENTION_LINK_HOVER_COLOR = exports.MENTION_LINK_HOVER_COLOR = '#33475b';
var DROPDOWN_BACKGROUND_COLOR = exports.DROPDOWN_BACKGROUND_COLOR = '#ffffff';
var DROPDOWN_BORDER_COLOR = exports.DROPDOWN_BORDER_COLOR = '#cbd6e2';
var DROPDOWN_SELECTED_BACKGROUND_COLOR = exports.DROPDOWN_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
var DROPDOWN_SEARCH_BACKGROUND_COLOR = exports.DROPDOWN_SEARCH_BACKGROUND_COLOR = '#ffffff';
var DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = exports.DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = '#eaf0f6';
var DROPDOWN_CARET_COLOR = exports.DROPDOWN_CARET_COLOR = '#00a4bd';
var TOOLBAR_DARK_BACKGROUND_COLOR = exports.TOOLBAR_DARK_BACKGROUND_COLOR = '#253342';
var TOOLBAR_DARK_FOREGROUND_COLOR = exports.TOOLBAR_DARK_FOREGROUND_COLOR = '#ffffff';
var EDITOR_LAYOUT_SHADOW_COLOR = exports.EDITOR_LAYOUT_SHADOW_COLOR = '#516f90';
var FORM_CONTROL_BACKGROUND_COLOR = exports.FORM_CONTROL_BACKGROUND_COLOR = '#f5f8fa';
var FORM_CONTROL_FOREGROUND_COLOR = exports.FORM_CONTROL_FOREGROUND_COLOR = '#33475b';
var FORM_CONTROL_BORDER_COLOR = exports.FORM_CONTROL_BORDER_COLOR = '#cbd6e2';
var FORM_CONTROL_READONLY_BACKGROUND_COLOR = exports.FORM_CONTROL_READONLY_BACKGROUND_COLOR = '#eaf0f6';
var FORM_CONTROL_READONLY_BORDER_COLOR = exports.FORM_CONTROL_READONLY_BORDER_COLOR = '#eaf0f6';
var FORM_COPYABLE_BACKGROUND_COLOR = exports.FORM_COPYABLE_BACKGROUND_COLOR = '#ffffff';
var FORM_DISABLED_COLOR = exports.FORM_DISABLED_COLOR = '#cbd6e2';
var FORM_DISABLED_BACKGROUND_COLOR = exports.FORM_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
var FORM_PLACEHOLDER_COLOR = exports.FORM_PLACEHOLDER_COLOR = '#7c98b6';
var FORM_STATIC_LABELS_BACKGROUND_COLOR = exports.FORM_STATIC_LABELS_BACKGROUND_COLOR = '#eaf0f6';
var FORM_STATIC_LABELS_COLOR = exports.FORM_STATIC_LABELS_COLOR = '#7c98b6';
var FORM_TOGGLE_BACKGROUND_COLOR = exports.FORM_TOGGLE_BACKGROUND_COLOR = '#ffffff';
var FORM_TOGGLE_HOVER_BACKGROUND_COLOR = exports.FORM_TOGGLE_HOVER_BACKGROUND_COLOR = '#eaf0f6';
var FORM_TOGGLE_BORDER_COLOR = exports.FORM_TOGGLE_BORDER_COLOR = '#cbd6e2';
var FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = exports.FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = '#99acc2';
var FORM_TOGGLE_HOVER_FOREGROUND_COLOR = exports.FORM_TOGGLE_HOVER_FOREGROUND_COLOR = '#0091ae';
var FORM_TOGGLE_ICON_COLOR = exports.FORM_TOGGLE_ICON_COLOR = '#99acc2';
var FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = exports.FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = '#ffffff';
var FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = exports.FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = '#00a4bd';
var HR_BORDER_COLOR = exports.HR_BORDER_COLOR = '#dfe3eb';
var ICON_DEFAULT_COLOR = exports.ICON_DEFAULT_COLOR = '#7c98b6';
var MODAL_BACKGROUND_COLOR = exports.MODAL_BACKGROUND_COLOR = '#ffffff';
var MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = exports.MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = '#99acc2';
var MODAL_DANGER_FOREGROUND_COLOR = exports.MODAL_DANGER_FOREGROUND_COLOR = '#ffffff';
var MODAL_FOOTER_BACKGROUND_COLOR = exports.MODAL_FOOTER_BACKGROUND_COLOR = '#ffffff';
var MODAL_HEADER_BACKGROUND_COLOR = exports.MODAL_HEADER_BACKGROUND_COLOR = '#00bda5';
var MODAL_HEADER_FOREGROUND_COLOR = exports.MODAL_HEADER_FOREGROUND_COLOR = '#ffffff';
var MODAL_HEADER_START_GRADIENT = exports.MODAL_HEADER_START_GRADIENT = '#00a4bd';
var MODAL_HEADER_MIDDLE_GRADIENT = exports.MODAL_HEADER_MIDDLE_GRADIENT = '#00afb2';
var MODAL_HEADER_END_GRADIENT = exports.MODAL_HEADER_END_GRADIENT = '#00bda5';
var MODAL_HEADING_INVERTED_FOREGROUND_COLOR = exports.MODAL_HEADING_INVERTED_FOREGROUND_COLOR = '#ffffff';
var MODAL_UPGRADES_FOREGROUND_COLOR = exports.MODAL_UPGRADES_FOREGROUND_COLOR = '#ffffff';
var MODAL_UPGRADES_END_GRADIENT = exports.MODAL_UPGRADES_END_GRADIENT = '#ff8f59';
var MODAL_UPGRADES_START_GRADIENT = exports.MODAL_UPGRADES_START_GRADIENT = '#ff7a59';
var MODAL_SUCCESS_BACKGROUND_COLOR = exports.MODAL_SUCCESS_BACKGROUND_COLOR = '#00bda5';
var MODAL_SUCCESS_FOREGROUND_COLOR = exports.MODAL_SUCCESS_FOREGROUND_COLOR = '#ffffff';
var PAGINATION_ACTIVE_BACKGROUND_COLOR = exports.PAGINATION_ACTIVE_BACKGROUND_COLOR = '#cbd6e2';
var PAGINATION_HOVER_BACKGROUND_COLOR = exports.PAGINATION_HOVER_BACKGROUND_COLOR = '#eaf0f6';
var PAGINATION_SELECTED_BACKGROUND_COLOR = exports.PAGINATION_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
var PAGINATION_SELECTED_BORDER_COLOR = exports.PAGINATION_SELECTED_BORDER_COLOR = '#7fd1de';
var SELECTABLE_BOX_BORDER_COLOR = exports.SELECTABLE_BOX_BORDER_COLOR = '#7fd1de';
var SELECTABLE_BOX_SHADOW_COLOR = exports.SELECTABLE_BOX_SHADOW_COLOR = 'rgba(0, 163, 189, .3)';
var SELECTABLE_BOX_SELECTED_BORDER_COLOR = exports.SELECTABLE_BOX_SELECTED_BORDER_COLOR = '#00a4bd';
var SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = exports.SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
var SIDENAV_FOREGROUND_COLOR = exports.SIDENAV_FOREGROUND_COLOR = '#33475b';
var SIDENAV_HOVERED_BACKGROUND_COLOR = exports.SIDENAV_HOVERED_BACKGROUND_COLOR = '#eaf0f6';
var SIDENAV_SELECTED_BACKGROUND_COLOR = exports.SIDENAV_SELECTED_BACKGROUND_COLOR = '#eaf0f6';
var TABLE_SORT_ARROW_COLOR = exports.TABLE_SORT_ARROW_COLOR = '#cbd6e2';
var TABLE_SORT_ARROW_SELECTED_COLOR = exports.TABLE_SORT_ARROW_SELECTED_COLOR = '#00a4bd';
var LOADING_INACTIVE_COLOR = exports.LOADING_INACTIVE_COLOR = '#cbd6e2';
var LOADING_DEFAULT_COLOR = exports.LOADING_DEFAULT_COLOR = '#00a4bd';
var OVERLAY_BACKGROUND_COLOR = exports.OVERLAY_BACKGROUND_COLOR = '#2d3e50';
var OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = exports.OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = 'rgba(45, 62, 80, 0.79)';
var PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = exports.PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = '#ffffff';
var PANEL_FOOTER_BACKGROUND_COLOR = exports.PANEL_FOOTER_BACKGROUND_COLOR = '#f5f8fa';
var PANEL_FOOTER_BORDER_COLOR = exports.PANEL_FOOTER_BORDER_COLOR = '#cbd6e2';
var PANEL_SHADOW_COLOR = exports.PANEL_SHADOW_COLOR = 'rgba(66, 91, 118, 0.21)';
var TABLE_BACKGROUND_COLOR = exports.TABLE_BACKGROUND_COLOR = '#ffffff';
var TABLE_BORDER_COLOR = exports.TABLE_BORDER_COLOR = '#dfe3eb';
var TABLE_HEADER_BACKGROUND_COLOR = exports.TABLE_HEADER_BACKGROUND_COLOR = '#f5f8fa';
var TABLE_ROW_HOVER_BACKGROUND_COLOR = exports.TABLE_ROW_HOVER_BACKGROUND_COLOR = '#f5f8fa';
var TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = exports.TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = '#e5f5f8';
var TABLE_SORTABLE_HOVER_ICON_COLOR = exports.TABLE_SORTABLE_HOVER_ICON_COLOR = '#7c98b6';
var TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = exports.TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = '#eaf0f6';
var TAG_AVATAR_BORDER_COLOR = exports.TAG_AVATAR_BORDER_COLOR = '#7fd1de';
var TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = exports.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = '#cbd6e2';
var TOOLTIP_FOREGROUND_COLOR = exports.TOOLTIP_FOREGROUND_COLOR = '#ffffff';
var TOOLTIP_DANGER_BACKGROUND_COLOR = exports.TOOLTIP_DANGER_BACKGROUND_COLOR = '#f2545b';
var TOOLTIP_DEFAULT_BACKGROUND_COLOR = exports.TOOLTIP_DEFAULT_BACKGROUND_COLOR = '#425b76';
var TOOLTIP_LONGFORM_BACKGROUND_COLOR = exports.TOOLTIP_LONGFORM_BACKGROUND_COLOR = '#ffffff';
var TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = exports.TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = '#0091ae';
var TOOLTIP_LONGFORM_FOCUS_COLOR = exports.TOOLTIP_LONGFORM_FOCUS_COLOR = '#00a4bd';
var WIZARD_HEADER_BACKGROUND_COLOR = exports.WIZARD_HEADER_BACKGROUND_COLOR = '#ffffff';
var WIZARD_HEADER_BORDER_COLOR = exports.WIZARD_HEADER_BORDER_COLOR = '#cbd6e2';
var DEVICE_FRAME_COLOR = exports.DEVICE_FRAME_COLOR = '#7c98b6';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/HubStyleTokens/static-2.2354/js/theme.js
// module id = 26
// module chunks = 177